import React, { useEffect } from "react";
import AppealOutcomeComponentLegacy from "../../../components/applicationComponents/legacy/appealOutcome/appealOutcomeComponentLegacy";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";

export default function AppealOutcomePageLegacy() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Appeal Outcome",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <AppealOutcomeComponentLegacy disabled={false} />
    </>
  );
}
